import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const KontaktySpravaPage = lazy(() =>
  import('@/modules/kontakty/KontaktySpravaPage').then((m) => ({ default: m.KontaktySpravaPage })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/kontakty/sprava',
  component: () => (
    <Suspense fallback={null}>
      <KontaktySpravaPage />
    </Suspense>
  ),
});
